// 文字<=>数値　対応
const vin_char_to_number_convert_table = new Map([
	['A', 1],
	['B', 2],
	['C', 3],
	['D', 4],
	['E', 5],
	['F', 6],
	['G', 7],
	['H', 8],
	['I', null],
	['J', 1],
	['K', 2],
	['L', 3],
	['M', 4],
	['N', 5],
	['O', null],
	['P', 7],
	['Q', null],
	['R', 9],
	['S', 2],
	['T', 3],
	['U', 4],
	['V', 5],
	['W', 6],
	['X', 7],
	['Y', 8],
	['Z', 9],
]);

//各桁に対する加重値
const each_weighted_value_table = new Map([
	[1, 8],
	[2, 7],
	[3, 6],
	[4, 5],
	[5, 4],
	[6, 3],
	[7, 2],
	[8, 10],
	[9, 0],
	[10, 9],
	[11, 8],
	[12, 7],
	[13, 6],
	[14, 5],
	[15, 4],
	[16, 3],
	[17, 2],
]);

function checkDigit(vin: string) {
	if (vin.length !== 17) return false;
	if (vin.match(/\*|#|-/)) return true;

	const check_digit = vin[8];
	const sum = vin
		.split('')
		.map((code, index) => {
			const number_code = vin_char_to_number_convert_table.get(code) ?? Number(code);
			// console.log('コード：' + number_code);
			const weighted_value = each_weighted_value_table.get(index + 1);
			// console.log('加重値：' + weighted_value);
			const product = number_code * weighted_value; //積
			// console.log('積：' + product);
			return product;
		})
		.reduce((a, b) => a + b, 0);
	// console.log(sum);

	const mod = sum % 11;
	// console.log(mod);

	const mod_to_code = mod === 10 ? 'X' : String(mod);
	// console.log(`${mod_to_code} = ${check_digit} ？`);

	return check_digit === mod_to_code;
}

// in-source test suites
if (import.meta.vitest) {
	const { it, expect } = import.meta.vitest;
	it('checkDigit [empty]', () => {
		expect(checkDigit('')).toBe(false);
	});
	it('checkDigit [too short]', () => {
		expect(checkDigit('12546')).toBe(false);
	});
	it('checkDigit [all one]', () => {
		expect(checkDigit('11111' + '11111' + '11111' + '11')).toBe(true);
	});
	it('checkDigit [invalid vin]', () => {
		expect(checkDigit('2B6JB23Y6JK127592')).toBe(false);
	});
	it('checkDigit [success vin]', () => {
		expect(checkDigit('1GTGC24W8GS527718')).toBe(true);
	});
}

export { checkDigit };
